import { angelSocials } from "constants/constants";
import { FaTwitter, FaMedium, FaTelegram, FaYoutube, FaDiscord } from "react-icons/fa";
import { Link } from "react-router-dom";
import st_foot from "./Footer.module.css";

const Footer = () => {

    return (
        <footer className={st_foot.footer}>
            <div className={st_foot.left}>
                <div className={st_foot.socials}>
                    <a target="_blank" href={angelSocials.twitter}><FaTwitter/></a>
                    <a target="_blank" href={angelSocials.telegram}><FaTelegram/></a>
                    <a target="_blank" href={angelSocials.youtube}><FaYoutube/></a>
                    <a target="_blank" href={angelSocials.medium}><FaMedium/></a>
                    <a target="_blank" href={angelSocials.discord}><FaDiscord/></a>
                </div>
                <div className={st_foot.info}>
                    <Link 
                    className={st_foot.litepaper}
                    download to="/ap-litepaper.pdf"
                    target="_blank">
                        DOWNLOAD LITEPAPER
                    </Link>
                    <p>COPYRIGHT 2022 ANGEL PROTOCOL. ALL RIGHTS RESERVED.</p>
                </div>
            </div>
            {/* <div>
            <div className={st_foot.right}>
                    Hello
                </div>
                <div>
                    Hello
                </div>
            </div> */}
        </footer>
    )
}

export default Footer;